(function () {
  // ✅ NUMBER for comparison with cart.js response
  const FREE_GIFT_VARIANT_ID = 46214724223151;
  // ✅ STRING for sending to cart/add.js API
  const FREE_GIFT_VARIANT_ID_STR = "46214724223151";
  const CART_THRESHOLD = 200000; // ₹2000 in paise

  let isRunning = false;
  let lastKnownTotal = -1;
  let lastGiftKey = null;

  function log(msg) {
    console.log('[FreeGift]', msg);
  }

  function wasManuallyRemoved() {
    return sessionStorage.getItem('giftManuallyRemoved') === 'true';
  }

  function setManuallyRemoved(val) {
    sessionStorage.setItem('giftManuallyRemoved', String(val));
  }

  // ✅ Use XMLHttpRequest instead of fetch entirely
  // Avoids all fetch interception conflicts with theme JS
  function xhrJSON(method, url, body) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = () => {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => reject(new Error('XHR failed'));
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  async function getCart() {
    return xhrJSON('GET', '/cart.js');
  }

  async function addGift() {
    log('Adding free gift...');
    await xhrJSON('POST', '/cart/add.js', {
      items: [{
        id: FREE_GIFT_VARIANT_ID_STR, // ✅ STRING for API request
        quantity: 1,
        properties: { _isFreeGift: 'true' }
      }]
    });
    log('Gift added.');
  }

  async function removeGift(lineKey) {
    log('Removing free gift: ' + lineKey);
    await xhrJSON('POST', '/cart/change.js', {
      id: lineKey,
      quantity: 0
    });
    log('Gift removed.');
  }

  async function runGiftLogic() {
    // ✅ Hard lock — only one run at a time
    if (isRunning) {
      log('Already running, skipping.');
      return;
    }
    isRunning = true;

    try {
      const cart = await getCart();

      // ✅ NUMBER comparison — cart.js returns numbers
      const giftItem = cart.items.find(i => i.variant_id === FREE_GIFT_VARIANT_ID);
      const nonGiftItems = cart.items.filter(i => i.variant_id !== FREE_GIFT_VARIANT_ID);
      const totalWithoutGift = nonGiftItems.reduce((sum, i) => sum + i.line_price, 0);

      log('Total without gift (paise): ' + totalWithoutGift);
      log('Gift in cart: ' + !!giftItem);
      log('Manually removed: ' + wasManuallyRemoved());

      // Save gift key whenever we see it
      if (giftItem) lastGiftKey = giftItem.key;

      // ✅ Cart is empty — clean up gift if somehow there
      if (nonGiftItems.length === 0) {
        if (giftItem) {
          await removeGift(giftItem.key);
          lastGiftKey = null;
        }
        setManuallyRemoved('false');
        lastKnownTotal = 0;
        return;
      }

      // ✅ Nothing changed and gift qty is correct — skip
      if (totalWithoutGift === lastKnownTotal && giftItem && giftItem.quantity === 1) {
        log('No change detected, skipping.');
        return;
      }

      lastKnownTotal = totalWithoutGift;

      if (totalWithoutGift >= CART_THRESHOLD) {
        // Above threshold
        if (!giftItem) {
          if (!wasManuallyRemoved()) {
            await addGift();
          } else {
            log('Manually removed — not re-adding.');
          }
        } else if (giftItem.quantity > 1) {
          // ✅ Fix quantity if somehow more than 1
          log('Fixing gift quantity...');
          await removeGift(giftItem.key);
          lastGiftKey = null;
          await addGift();
        }
        // quantity is 1 and gift is there — perfect, do nothing
      } else {
        // Below threshold — always remove gift
        if (giftItem) {
          await removeGift(giftItem.key);
          lastGiftKey = null;
          setManuallyRemoved('false'); // reset so it re-adds if threshold is met again
        } else {
          setManuallyRemoved('false');
        }
      }
    } catch (e) {
      console.error('[FreeGift] Error:', e);
    } finally {
      // ✅ Always release the lock
      isRunning = false;
    }
  }

  // ✅ Watch for cart changes by intercepting fetch
  // Theme cart drawer uses fetch — we listen and react
  const _origFetch = window.fetch.bind(window);
  window._originalFetch = _origFetch;

  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const body = args[1]?.body || '';
    const bodyStr = typeof body === 'string' ? body : JSON.stringify(body);

    // Run the original fetch first
    const result = await _origFetch.apply(this, args);

    const isCartMutation =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update');

    // ✅ Skip our OWN calls (identified by _isFreeGift property)
    const isOurCall = bodyStr.includes('_isFreeGift');

    if (isCartMutation && !isOurCall) {
      // ✅ Detect if customer manually removed the gift
      if (url.includes('/cart/change')) {
        try {
          const parsed = JSON.parse(bodyStr);
          const isRemoval = parsed.quantity === 0;
          const targetsGift =
            bodyStr.includes(FREE_GIFT_VARIANT_ID_STR) ||
            (lastGiftKey && bodyStr.includes(lastGiftKey));

          if (isRemoval && targetsGift) {
            log('Customer manually removed gift.');
            setManuallyRemoved('true');
          }
        } catch (e) {}
      }

      // ✅ Wait for cart to settle then run logic once
      setTimeout(runGiftLogic, 600);
    }

    return result;
  };

  // ✅ Run on page load
  log('Script loaded. Running init...');
  runGiftLogic();

})();